import { render, staticRenderFns } from "./RejectedPackingListTable.vue?vue&type=template&id=ed130954&"
import script from "./RejectedPackingListTable.vue?vue&type=script&lang=js&"
export * from "./RejectedPackingListTable.vue?vue&type=script&lang=js&"
import style0 from "./RejectedPackingListTable.vue?vue&type=style&index=0&id=ed130954&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports